<template>
  <div>
    <div class="breadcrumb-area">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2">
            <div class="breadcrumb-wrapper">
              <ul class="breadcrumb-list">
                <li>
                  <router-link :to="{ name: 'HomePage' }">
                    <i class="fa fa-home"></i>
                    Home
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'ProductList' }">
                    <i class="fa fa-stars"></i>
                    Star Collection
                  </router-link>
                </li>
                <li
                  class="active"
                  :class="{
                    'text-success': saved,
                    'text-warning': !saved,
                  }"
                >
                  <i class="fa fa-couch"></i>
                  {{ storeCart ? storeCart.Name : "My Collection" }}
                  <i v-if="saved" class="fa fa-lock-alt"></i>
                  <i v-else class="fa fa-unlock-alt"></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-content-wrapper">
      <div class="shopping-cart-area">
        <div class="container">
          <div class="text-center" v-if="loading">
            <div class="spinner-border text-info" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div class="row justify-content-lg-center" v-if="storeCart">
            <div class="col-lg-6" v-if="!saved">
              <div class="mb-2 row">
                <label class="col-sm-3 col-form-label">Collection Name</label>
                <div class="col-sm-9">
                  <input
                    type="text"
                    class="form-control"
                    v-model="collectionName"
                  />
                </div>
              </div>
              <div class="mb-2 row">
                <label class="col-sm-3 col-form-label">Note</label>
                <div class="col-sm-9">
                  <textarea
                    rows="3"
                    class="form-control"
                    v-model="collectionNote"
                  />
                </div>
              </div>
              <div class="mb-4 row">
                <div class="col-md-9 offset-md-3 text-end">
                  <button
                    class="btn btn-success btn-sm"
                    @click="saveCollection"
                  >
                    <i class="fa fa-lock-alt"></i>
                    Save
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-5" v-else-if="storeCart.Note">
              <textarea
                class="form-control mb-3"
                rows="3"
                :value="storeCart.Note"
                disabled
              >
              </textarea>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <div class="cart-table-container">
                <div
                  v-if="collection && collection.length && !saved"
                  class="d-lg-none d-md-block"
                >
                  <div class="row">
                    <div class="col-6 text-start">
                      <div class="check-box d-inline-block">
                        <input
                          type="checkbox"
                          v-model="selectedAll"
                          id="chk_All_Mobile"
                        />
                        <label for="chk_All_Mobile">&nbsp;</label>
                      </div>
                    </div>
                    <div class="col-6 text-end">
                      <a
                        href="javascript:"
                        class="btn btn-sm btn-danger mb-2"
                        title="Remove all"
                        @click="removeAllFromCollection"
                      >
                        <i class="fa fa-trash"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <table class="cart-table">
                  <thead>
                    <tr class="text-center">
                      <th class="product-subtotal">
                        <div class="check-box d-inline-block">
                          <input
                            type="checkbox"
                            v-model="selectedAll"
                            id="chk_All"
                          />
                          <label for="chk_All">&nbsp;</label>
                        </div>
                      </th>
                      <th class="product-name" colspan="2">Product</th>
                      <th class="product-price">Materials</th>
                      <th class="product-quantity">Volume</th>
                      <th class="product-subtotal" v-if="!isGuest">FOB/Unit</th>
                      <th class="product-subtotal" v-if="!isGuest">Total</th>
                      <th class="product-remove" v-if="!saved">
                        <a
                          v-if="collection && collection.length"
                          href="javascript:"
                          class="text-danger"
                          title="Remove all"
                          @click="removeAllFromCollection"
                        >
                          <i class="fa fa-trash"></i>
                        </a>
                      </th>
                    </tr>
                  </thead>

                  <!-- <tbody v-if="collection && collection.length"> -->
                  <draggable
                    v-model="collection"
                    tag="tbody"
                    v-if="collection && collection.length"
                    v-bind="dragOptions"
                    handle=".handle"
                    @end="dragEnd"
                  >
                    <tr v-for="item in collection" :key="`item-${item.Id}`">
                      <td
                        class="product-subtotal text-center position-relative"
                      >
                        <i
                          class="fa fa-align-justify handle position-absolute"
                          style="top: 0; left: 0; cursor: all-scroll"
                          title="Drag & Drop to change the item's position"
                        ></i>
                        <div class="check-box d-inline-block">
                          <input
                            type="checkbox"
                            v-model="item.Selected"
                            :id="`chk_${item.Id}`"
                          />
                          <label :for="`chk_${item.Id}`">&nbsp;</label>
                        </div>
                      </td>
                      <td class="product-thumbnail">
                        <router-link
                          :to="{
                            name: 'ProductDetail',
                            params: { slug: item.Slug },
                          }"
                          class="image-wrap"
                        >
                          <img
                            v-if="item.ImagePath"
                            :src="item.ImagePath"
                            class="img-fluid"
                            alt=""
                          />
                          <img
                            v-else
                            src="/img/No_Picture.png"
                            class="img-fluid"
                            alt=""
                          />
                        </router-link>
                      </td>
                      <td class="product-name" style="max-width: 300px">
                        <router-link
                          :to="{
                            name: 'ProductDetail',
                            params: { slug: item.Slug },
                          }"
                          class="text-primary mb-2"
                        >
                          {{ item.ProductName }}
                        </router-link>
                        <div class="small" v-if="item.ShortDescription">
                          {{ item.ShortDescription }}
                        </div>
                        <span class="product-variation" v-if="item.DrawingCode">
                          Drawing Code: {{ item.DrawingCode }}
                        </span>
                      </td>

                      <td>
                        <div
                          v-for="(material, i) in item.MaterialConfigs"
                          :key="`material-${i}`"
                        >
                          <span class="fw-bold">{{ material.Type }}:</span>
                          {{ material.Code }} -
                          {{ material.Name }}
                        </div>
                      </td>

                      <td class="text-center">
                        <div
                          v-if="!saved"
                          class="d-inline-block"
                          style="width: 100px"
                        >
                          <input
                            :value="item.Volume"
                            type="number"
                            class="form-control"
                            placeholder="Volume"
                            onClick="this.select();"
                            :min="item.MinVolume"
                            @change="(e) => updateVolumn(e, item)"
                          />
                        </div>
                        <div v-else>
                          {{
                            item.Volume && item.Volume != "0"
                              ? $func.addCommas(item.Volume)
                              : ""
                          }}
                        </div>
                      </td>

                      <td class="total-price text-center" v-if="!isGuest">
                        <div
                          v-if="!item.BasePrice && !saved && !isGuest"
                          class="d-inline-block"
                          style="width: 130px"
                        >
                          <div class="input-group input-group-sm">
                            <div class="input-group-prepend">
                              <div class="input-group-text">$</div>
                            </div>
                            <input
                              v-model="item.Price"
                              type="number"
                              class="form-control"
                              placeholder="Price"
                              onClick="this.select();"
                              @change="
                                (e) => updatePrice(e.target.value, item.Id)
                              "
                            />
                          </div>
                        </div>
                        <div v-else>
                          {{
                            item.Price && item.Price != "0"
                              ? `$${$func.addCommas(
                                  parseFloat(item.Price).toFixed(2)
                                )}`
                              : ""
                          }}
                        </div>
                      </td>

                      <td class="total-price text-end" v-if="!isGuest">
                        <span
                          class="me-2"
                          v-if="
                            item.Price &&
                            item.Price != '0' &&
                            item.Volume &&
                            item.Volume != '0'
                          "
                        >
                          ${{
                            $func.addCommas(
                              (
                                parseFloat(item.Price) * parseInt(item.Volume)
                              ).toFixed(2)
                            )
                          }}
                        </span>
                      </td>

                      <td class="product-remove" v-if="!saved">
                        <a
                          href="javascript:"
                          title="Remove this item"
                          @click="removeFromCollection(item.Id)"
                        >
                          <i class="fa fa-times"></i>
                        </a>
                      </td>
                    </tr>
                  </draggable>

                  <!-- </tbody> -->
                  <tbody v-else>
                    <tr>
                      <td colspan="100%">
                        <div class="text-center p-4">
                          <h5 class="text-warning">
                            There's no item in your collection.
                          </h5>
                          <p>
                            Go to the
                            <router-link
                              class="text-primary"
                              :to="{ name: 'ProductList' }"
                            >
                              Star Collection
                            </router-link>
                            to find more items you'd like to add.
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>

                  <tfoot v-if="total && !isGuest">
                    <tr class="text-center">
                      <th class="product-name" colspan="2"></th>
                      <th class="product-price"></th>
                      <th class="product-quantity"></th>
                      <th class="product-subtotal text-end" colspan="2">
                        ${{ $func.addCommas(total.toFixed(2)) }}
                      </th>
                      <th class="product-remove" v-if="!saved"></th>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <!--=======  End of cart table  =======-->
            </div>
          </div>
          <div class="row" v-if="collection && collection.length">
            <div class="col-md-6 mb-2">
              <router-link :to="{ name: 'ProductList' }" class="text-primary">
                <i class="fa fa-stars"></i>
                Go to Star Collection
              </router-link>
            </div>
            <div class="col-md-6 text-end mb-2">
              <div
                v-if="processing"
                class="spinner-border text-info"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
              <template v-else>
                <button
                  class="btn btn-sm btn-success"
                  @click="generateOfferSheet"
                  :disabled="
                    !collection || !collection.filter((_) => _.Selected).length
                  "
                >
                  <i class="fa fa-file-excel"></i>
                  Offer Sheet
                </button>
                <button
                  class="btn btn-sm btn-success ms-2"
                  @click="generatePresentation"
                  :disabled="
                    !collection || !collection.filter((_) => _.Selected).length
                  "
                >
                  <i class="fa fa-file-pdf"></i>
                  Collection Presentation
                </button>
              </template>

              <div v-if="allowPresentation">
                <vue-html2pdf
                  :show-layout="false"
                  :float-layout="true"
                  :enable-download="true"
                  :preview-modal="false"
                  :paginate-elements-by-height="1400"
                  filename="MyStarCollection"
                  :pdf-quality="2"
                  :manual-pagination="true"
                  pdf-format="a4"
                  pdf-orientation="portrait"
                  pdf-content-width="100%"
                  ref="html2Pdf"
                  @hasDownloaded="processing = false"
                >
                  <section slot="pdf-content">
                    <!-- PDF Content Here -->
                    <Download
                      :collection="collection.filter((_) => _.Selected)"
                      :storeCart="storeCart"
                    />
                  </section>
                </vue-html2pdf>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import Download from "./Download.vue";
import draggable from "vuedraggable";

export default {
  name: "MyCollection",
  components: {
    VueHtml2pdf,
    Download,
    draggable,
  },
  data() {
    return {
      allowPresentation: true,
      processing: false,
      userType: null,
      storeCart: null,
      collection: null,
      loading: false,
      collectionName: null,
      collectionNote: null,
    };
  },
  async mounted() {
    if (this.cartId) {
      await this.loadColletion(this.cartId);
    }
    let resp = await this.$http.get(`Settings/UserInfo`);
    if (resp && resp.status == 200 && resp.data) {
      let respData = resp.data;
      this.userType = respData.data.userType;
    }
  },
  computed: {
    cartId() {
      let cartId = this.$route.params.cartId;
      if (!cartId) {
        let cart = this.$collection.getters.cart;
        cartId = cart ? cart.Id : 0;
      }
      return cartId;
    },
    // storeCart() {
    //   return this.$collection.getters.cart;
    // },

    storeCollection() {
      let storeCart = this.storeCart;
      if (storeCart) {
        return storeCart.CartItems;
      }
      return [];
      //return this.$collection.getters.collection;
    },

    saved() {
      return this.storeCart &&
        this.storeCart.Status == this.$const.CART_STATUS.Saved
        ? true
        : false;
    },

    // loading: function() {
    //   return this.$collection.getters.loading;
    // },

    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: this.saved ? true : false,
        ghostClass: "ghost",
      };
    },

    total() {
      let collection = this.collection;
      if (collection && collection.length) {
        let total = 0;
        collection
          .filter((_) => _.Selected)
          .forEach((item) => {
            total +=
              (item.Volume ? parseInt(item.Volume) : 0) *
              (item.Price ? parseFloat(item.Price) : 0);
          });
        return total;
      }
      return 0;
    },

    selectedAll: {
      // getter
      get: function () {
        return this.collection && this.collection.length
          ? this.collection.length ==
              this.collection.filter((_) => _.Selected).length
          : false;
      },
      // setter
      set: function (newValue) {
        this.collection.forEach((_) => {
          _.Selected = newValue;
        });
      },
    },

    isGuest() {
      return this.userType == this.$const.USER_TYPES.Guest;
    },
  },
  watch: {
    async cartId(val) {
      if (val) {
        await this.loadColletion(val);
      }
    },
    storeCollection: {
      deep: true,
      async handler(val) {
        this.collection = await this.fromStoreCollections(val);
      },
    },
  },
  methods: {
    async loadColletion(cartId) {
      this.loading = true;
      let resp = await this.$http.get(`odata/Cart`, {
        params: {
          $top: 1,
          $filter: `Id eq ${cartId}`,
          $expand: `CartItems($orderby=DisplayOrder asc)`,
        },
      });
      if (resp && resp.status == 200) {
        let storeCart =
          resp.data.value && resp.data.value.length ? resp.data.value[0] : null;
        this.collectionName = storeCart ? storeCart.Name : null;
        this.collectionNote = storeCart ? storeCart.Note : null;
        this.storeCart = storeCart;
      }
      this.loading = false;
    },
    async fromStoreCollections(collection) {
      let productMoqs = [];
      let productIds =
        collection && collection.length
          ? [...new Set(collection.map((_) => _.ProductId))]
          : [];
      if (productIds && productIds.length) {
        let resp = await this.$http.get(`odata/ProductCategory`, {
          params: {
            $select: `ProductId`,
            $expand: `Category($select=Moq),Product($select=Price,PricePanel)`,
            $filter: `Status eq ${
              this.$const.STATUS.Active
            } and ProductId in (${productIds.join()})`,
          },
        });
        if (resp && resp.status == 200) {
          var respData = resp.data.value;
          productMoqs = respData.map((_) => {
            return {
              ProductId: _.ProductId,
              Moq: _.Category.Moq,
              Price: _.Product.Price,
              PricePanel: _.Product.PricePanel,
            };
          });
        }
      }

      return collection && collection.length
        ? collection.map((_) => {
            let productMoq =
              productMoqs && productMoqs.length
                ? productMoqs.find((m) => m.ProductId == _.ProductId)
                : null;
            let minVolume = productMoq ? productMoq.Moq : null;
            let info = _.Materials ? JSON.parse(_.Materials) : null;
            let materialConfigs = info ? info.MaterialConfigs : [];
            let basePrice = !this.isGuest
              ? this.getBasePrice(productMoq, materialConfigs)
              : null;
            return {
              Id: _.Id,
              ProductName: _.ProductName,
              Slug: _.Slug,
              ItemNumber: info ? info.ItemNumber : null,
              ProductType: info ? info.ProductType : null,
              MaterialConfigs: materialConfigs,
              ImagePath: _.ImagePath,
              DrawingCode: info ? info.DrawingCode : "TBA",
              ShortDescription: info ? info.ShortDescription : null,
              Description: info ? info.Description : null,
              LoadingInfo: info ? info.LoadingInfo : "TBA",
              OpenDimension: info ? info.OpenDimension : "TBA",
              Packing: info ? info.Packing : "TBA",
              CartonDimension: info ? info.CartonDimension : "TBA",
              PalletDimension: info ? info.PalletDimension : "TBA",
              ConLoad20Pcs: info ? info.ConLoad20Pcs : "",
              ConLoad40Pcs: info ? info.ConLoad40Pcs : "",
              ConLoad40HPcs: info ? info.ConLoad40HPcs : "",
              NetWeight: info ? info.NetWeight : "",
              GrossWeight: info ? info.GrossWeight : "",
              ConCbm3: info ? info.ConCbm3 : "",
              Volume: _.Volume ? _.Volume : minVolume,
              Price: basePrice ? basePrice : _.Price,
              DisplayOrder: _.DisplayOrder,
              MinVolume: minVolume,
              BasePrice: basePrice,
              Selected: true,
            };
          })
        : [];
    },

    async saveCollection() {
      let resp = await this.$http.patch(`odata/cart/${this.storeCart.Id}`, {
        Name: this.collectionName,
        Status: this.$const.CART_STATUS.Saved,
        Note: this.collectionNote,
      });
      if (resp && resp.status == 204) {
        this.$collection.dispatch("getUserCollection");
        this.$router.push({ name: "SavedCollections" });
      }
    },

    async removeFromCollection(itemId) {
      let result = await this.$swal({
        text: "Do you really want to remove this item from your collection?",
        icon: "question",
        showCancelButton: true,
      });
      if (result && result.isConfirmed) {
        this.$collection.dispatch("removeFromCart", itemId);
        this.collection = this.collection.filter((_) => _.Id != itemId);
      }
    },

    async removeAllFromCollection() {
      let result = await this.$swal({
        text: "Do you really want to remove all items from your collection?",
        icon: "question",
        showCancelButton: true,
      });
      if (result && result.isConfirmed) {
        await this.$func.asyncForEach(this.collection, async (item) => {
          await this.$collection.dispatch("removeFromCart", item.Id);
          this.collection = this.collection.filter((_) => _.Id != item.Id);
        });
      }
    },

    async updateVolumn(e, item) {
      let value = e.target.value;
      let itemId = item.Id;
      let volumn = null;
      if (value) {
        if (item.MinVolume && value && parseInt(value) < item.MinVolume) {
          value = item.MinVolume;
        }
        volumn = value == "0" ? null : value;
      }
      if (item.Volume != volumn) {
        item.Volume = volumn;
        await this.$http.patch(`odata/CartItem/${itemId}`, {
          Volume: volumn ? parseInt(volumn) : null,
        });
      }
      this.$forceUpdate();
    },

    async updatePrice(value, itemId) {
      let price = null;
      if (value) {
        price = value == "0" ? null : value;
      }
      await this.$http.patch(`odata/CartItem/${itemId}`, {
        Price: price ? parseFloat(price) : null,
      });
    },

    generatePresentation() {
      this.processing = true;
      this.allowPresentation = true;
      setTimeout(() => {
        this.$refs.html2Pdf.generatePdf();
      }, 3000);
    },

    async generateOfferSheet() {
      this.processing = true;
      let totalVolume = this.collection
        .filter((_) => _.Selected && _.Volume)
        .map((_) => parseInt(_.Volume))
        .reduce((pre, cur) => pre + cur);
      let totalAmount = this.collection
        .filter((_) => _.Selected && _.Price && _.Volume)
        .map((_) => parseFloat(_.Price * _.Volume))
        .reduce((pre, cur) => pre + cur);
      let model = {
        totalVolume: totalVolume ? this.$func.addCommas(totalVolume) : null,
        totalAmount: totalAmount
          ? this.$func.addCommas(totalAmount.toFixed(2))
          : null,
        cart: this.storeCart,
        cartItems: this.collection
          .filter((_) => _.Selected)
          .map((_) => {
            let volume = 0;
            let price = 0;
            if (_.Volume && _.Volume != "0") {
              volume = parseInt(_.Volume);
              _.Volume = this.$func.addCommas(_.Volume);
            }
            if (_.Price && _.Price != "0") {
              price = parseFloat(_.Price);
              _.Price = this.$func.addCommas(price.toFixed(2));
            }
            if (volume && price) {
              _.Total = this.$func.addCommas((volume * price).toFixed(2));
            }
            // no item number
            _.ItemNumber = null;
            return _;
          }),
      };
      let resp = await this.$http.post(`CartItem/OfferSheet`, model, {
        responseType: "blob",
      });
      this.processing = false;
      if (resp && resp.status == 200 && resp.data) {
        this.getBlob(resp.data, "MyStarCollection.xlsx");
      }
    },

    getBlob(blob, filename) {
      //IE11 & Edge
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = objectUrl;
        a.style = "display: none";
        a.download = filename; // gives it a name via an a tag
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(objectUrl);
        document.body.removeChild(a);
      }
    },

    getBasePrice(productDetail, materials) {
      if (productDetail && productDetail.Price) {
        let price = productDetail.Price;
        if (productDetail.PricePanel) {
          let isSidePanel = materials.some(
            (m) => m.Type == "SIDE PANELS" && m.Code != "NONE"
          );
          if (isSidePanel) {
            price = productDetail.PricePanel;
          }
        }
        return price;
      }
      return 0;
    },

    dragEnd() {
      this.$func.asyncForEach(this.collection, async (item, i) => {
        let order = i + 1;
        if (item.DisplayOrder != order) {
          item.DisplayOrder = order;
          await this.$http.patch(`odata/CartItem/${item.Id}`, {
            DisplayOrder: order,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.input-group .btn {
  z-index: 0;
}
</style>
